import { QuestionnaireAnswerType } from 'components/Assessments/types'
import { HistoryQuestionnaireItem } from './questionnaire'

export const HISTORY_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE = {
  [HistoryQuestionnaireItem.MEDICAL_BACKGROUND_HISTORY_FUNCTIONAL_LIMITATIONS]:
    QuestionnaireAnswerType.STRING,
  [HistoryQuestionnaireItem.MEDICAL_BACKGROUND_HISTORY_ACTIVITIES_PERMITTED]:
    QuestionnaireAnswerType.STRING,
  [HistoryQuestionnaireItem.MEDICAL_BACKGROUND_HISTORY_MEDICAL_HISTORY]:
    QuestionnaireAnswerType.STRING,
  [HistoryQuestionnaireItem.MEDICAL_BACKGROUND_HISTORY_SURGICAL_HISTORY]:
    QuestionnaireAnswerType.STRING
}
